import { useEffect, useState } from "react";
import mammoth from "mammoth";

export const useDocxViewer = (fileUrl: string) => {
  const [content, setContent] = useState<string | null>(null);
  useEffect(() => {
    const fetchDocxContent = async () => {
      try {
        const response = await fetch(fileUrl);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const arrayBuffer = await response.arrayBuffer();

        if (arrayBuffer.byteLength === 0) {
          throw new Error("ArrayBuffer is empty.");
        }

        const result = await mammoth.convertToHtml({ arrayBuffer });
        setContent(result.value);
      } catch (error) {
        console.error("Error fetching or converting the docx file:", error);
        setContent("<p>Error loading the document.</p>");
      }
    };

    if (fileUrl) {
      fetchDocxContent();
    }
  }, [fileUrl]);

  return content;
};
